import React, { useState } from "react";
import { Menu, Sun, Moon, X, UserRound, Home, LogOut, Eye, EyeClosed, CircleHelp, QrCode } from "lucide-react";
import { useNavigate } from 'react-router-dom';
import TempStorage from "../components/Storage.js"
import Loader from "./Loader.js";
import { useDarkMode } from '../components/DarkModeContext.js';

export let infoUtente = {};
let isLoading = false;


const PopUpChangePassword = ({ isVisible, setIsVisible }) => {
    const [vecchiaPassword, setVecchiaPassword] = useState("");
    const [isVecchiaPasswordVisible, setIsVecchiaPasswordVisible] = useState(false);
    const [nuovaPassword, setNuovaPassword] = useState("");
    const [isNuovaPasswordVisible, setIsNuovaPasswordVisible] = useState(false);
    const [confermaPassword, setConfermaPassword] = useState("");
    const [isConfermaPasswordVisible, setIsConfermaPasswordVisible] = useState(false);

    const closeModal = () => {
        setIsVisible(false);
    };

    const handleConferma = async () => {
        //Contollo la vechia password
        try {
            isLoading = true;
            const response = await fetch('/login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ Email: infoUtente["Email"], Password: vecchiaPassword, CodiceDispositivo: "ignore" }),
            });
            const data = await response.json();
            if (response.status === 401) {
                alert(data['error']);
                setVecchiaPassword('');
                return;
            }
            isLoading = false;
        } catch (error) {
            alert("Errore nell'operazione");
            console.log(error);
            return;
        }

        //Controllo che la nuova password rispetti i requisiti
        if (!checkPassword(nuovaPassword)) {
            alert('La nuova password non rispetta i requisiti');
            setNuovaPassword('');
            setConfermaPassword('');
            return;
        }

        //Controllo che la nuova password e la conferma password siano uguali
        if (nuovaPassword !== confermaPassword) {
            alert('Le password non coincidono');
            setNuovaPassword('');
            setConfermaPassword('');
            return;
        }

        //Confermo
        try {
            isLoading = true;
            const response = await fetch('/aggiornaPassword', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ ID: infoUtente["ID"], Password: nuovaPassword }),
            });


            if (response.status === 200) {
                isLoading = false;
                closeModal();
            }
            else {
                const data = await response.json();
                alert(data.error);
                console.log(data.error);
            }
        } catch (error) {
            alert("Errore nell'operazione");
            console.log(error);
            return;
        }
    };

    const checkPassword = (password) => {
        let check = true;
        const uppercasePattern = /[A-Z]/;
        const lowercasePattern = /[a-z]/;
        const specialCharPattern = /[!@#$%^&*(),.?":{}|<>]/;
        const numberPattern = /[0-9]/;

        if (!uppercasePattern.test(password)) {
            check = false;
        }
        if (!lowercasePattern.test(password)) {
            check = false;
        }
        if (!specialCharPattern.test(password)) {
            check = false;
        }
        if (!numberPattern.test(password)) {
            check = false;
        }
        if (password.length < 8) {
            check = false;
        }

        return check;
    }

    if (!isVisible) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 back">
            <div className="bg-white dark:bg-gray-800 rounded-lg p-6 w-100 max-w-[90vw] text-black dark:text-white">
                <div className="flex justify-center items-center mb-6">
                    <h2 className="text-xl font-bold justify-self-center">Cambia Password</h2>
                </div>
                <div className="">
                    <div className="mb-2 grid grid-cols-2 items-center">
                        <p className="justify-self-start">Vecchia password: </p>
                        <div className="relative flex items-center">
                            <input
                                type={isVecchiaPasswordVisible ? "text" : "password"}
                                placeholder=""
                                value={vecchiaPassword}
                                onChange={(e) => setVecchiaPassword(e.target.value)}
                                className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1 w-full"
                            />
                            <button
                                type="button"
                                onClick={() => setIsVecchiaPasswordVisible(!isVecchiaPasswordVisible)}
                                className="absolute right-2 text-black dark:text-white"
                            >
                                {isVecchiaPasswordVisible ? (
                                    <EyeClosed size={20} />
                                ) : (
                                    <Eye size={20} />
                                )}
                            </button>
                        </div>
                    </div>
                    <div className="mb-2 grid grid-cols-2 items-center">
                        <p className="justify-self-start flex items-center">Nuova password:
                            <button
                                type="button"
                                className="text-blue-500 ml-2"
                                onClick={() => alert('La password deve contenere almeno 8 caratteri, di cui almeno una lettera maiuscola, una minuscola, un numero e un carattere speciale (es. [!@#$%^&*(),.?":{}|<>])')}
                            >
                                <CircleHelp size={20} />
                            </button>
                        </p>
                        <div className="relative flex items-center">
                            <input
                                type={isNuovaPasswordVisible ? "text" : "password"}
                                placeholder=""
                                value={nuovaPassword}
                                onChange={(e) => setNuovaPassword(e.target.value)}
                                className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1 w-full"
                            />
                            <button
                                type="button"
                                onClick={() => setIsNuovaPasswordVisible(!isNuovaPasswordVisible)}
                                className="absolute right-2 text-black dark:text-white"
                            >
                                {isNuovaPasswordVisible ? (
                                    <EyeClosed size={20} />
                                ) : (
                                    <Eye size={20} />
                                )}
                            </button>
                        </div>
                    </div>
                    <div className="mb-2 grid grid-cols-2 items-center">
                        <p className="justify-self-start">Conferma password: </p>
                        <div className="relative flex items-center ">
                            <input
                                type={isConfermaPasswordVisible ? "text" : "password"}
                                placeholder=""
                                value={confermaPassword}
                                onChange={(e) => setConfermaPassword(e.target.value)}
                                className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1 w-full"
                            />
                            <button
                                type="button"
                                onClick={() => setIsConfermaPasswordVisible(!isConfermaPasswordVisible)}
                                className="absolute right-2 text-black dark:text-white"
                            >
                                {isConfermaPasswordVisible ? (
                                    <EyeClosed size={20} />
                                ) : (
                                    <Eye size={20} />
                                )}
                            </button>
                        </div>
                    </div>
                </div>
                <div className='mt-3 grid grid-cols-2'>
                    <button
                        onClick={closeModal}
                        className="mr-1 rounded-md py-2 px-4 bg-red-500 hover:bg-red-700 text-white font-bold"
                    >
                        Annulla
                    </button>
                    <button
                        onClick={handleConferma}
                        className="ml-1 rounded-md py-2 px-4 bg-green-500 hover:bg-green-700 text-white font-bold"
                    >
                        Conferma
                    </button>
                </div>
            </div>
        </div>
    );
};

const PopUpProfilo = ({ isVisible, setIsVisible }) => {
    const [isPasswordChangeVisible, setIsPasswordChangeVisible] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [nome, setNome] = useState(infoUtente['Nome']);
    const [cognome, setCognome] = useState(infoUtente['Cognome']);
    const [email, setEmail] = useState(infoUtente['Email']);

    const closeModal = () => {
        setIsVisible(false);
    };

    const handleChangePassword = () => {
        setIsPasswordChangeVisible(true);
    };

    const checkEmail = async () => {
        if (email === "" || email === infoUtente["Email"]) return;
        try {
            const response = await fetch('/checkEmail', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ Email: email }),
            });
            if (response.status === 401) {
                const data = await response.json();
                alert(data['error']);
                setEmail(infoUtente['Email']);
            }
        } catch (error) {
            alert('Errore nel controllo della mail, riprovare più tardi.');
            console.log(error);
        }

    };

    const handleAnnulla = () => {
        setNome(infoUtente['Nome']);
        setCognome(infoUtente['Cognome']);
        setEmail(infoUtente['Email']);
        setIsEditing(false);
    };

    const handleConferma = async () => {
        try {
            isLoading = true;
            const response = await fetch('/aggiornaUtente', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ ID: infoUtente['ID'], Nome: nome, Cognome: cognome, Email: email })
            });

            if (response.status === 500) {
                const data = await response.json();
                alert(data.error);
                console.log(data.error);
            }
            else {
                isLoading = false;
                setIsEditing(false);
                window.location.reload();
            }
        } catch (error) {
            alert("Errore nell'operazione, riprovare più tardi");
            console.log(error);
        }
    };

    if (!isVisible) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 back">
            <div className="bg-white dark:bg-gray-800 rounded-lg p-6 w-100 max-w-[90vw] text-black dark:text-white">
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-xl font-bold">Profilo</h2>
                    <button className="text-red-500" onClick={closeModal}>
                        <X size={24} />
                    </button>
                </div>
                <div>
                    <div className="mb-2 grid grid-cols-2 items-center">
                        <p className="justify-self-start">Nome: </p>
                        {
                            isEditing ? (
                                <input type="text" value={nome} onChange={(e) => setNome(e.target.value)} className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1" />
                            ) : (
                                <p className="rounded w-full bg-white dark:bg-gray-800">{nome}</p>
                            )
                        }
                    </div>
                    <div className="mb-2 grid grid-cols-2 items-center">
                        <p className="justify-self-start">Cognome: </p>
                        {
                            isEditing ? (
                                <input type="text" value={cognome} onChange={(e) => setCognome(e.target.value)} className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1" />
                            ) : (
                                <p className="rounded w-full bg-white dark:bg-gray-800">{cognome}</p>
                            )
                        }
                    </div>
                    <div className="mb-2 grid grid-cols-2 items-center">
                        <p className="justify-self-start">Email: </p>
                        {
                            isEditing ? (
                                <input type="text" value={email} onChange={(e) => setEmail(e.target.value)} onBlur={checkEmail} className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1" />
                            ) : (
                                <p className="rounded w-full bg-white dark:bg-gray-800">{email}</p>
                            )
                        }
                    </div>
                    <div className='grid grid-cols-2'>
                        {
                            isEditing ? (
                                <>
                                    <button
                                        onClick={handleAnnulla}
                                        className="mr-1 rounded-md py-2 px-4 bg-red-500 hover:bg-red-700 text-white font-bold"
                                    >
                                        Annulla
                                    </button>
                                    <button
                                        onClick={handleConferma}
                                        className="ml-1 rounded-md py-2 px-4 bg-green-500 hover:bg-green-700 text-white font-bold"
                                    >
                                        Conferma
                                    </button>
                                </>
                            ) : (
                                <>
                                    <button className="mr-1 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-4" onClick={() => setIsEditing(true)}>
                                        Modifica Profilo
                                    </button>
                                    <button className="ml-1 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-4" onClick={handleChangePassword}>
                                        Cambia Password
                                    </button>
                                </>
                            )
                        }

                    </div>
                </div>
            </div>
            <PopUpChangePassword isVisible={isPasswordChangeVisible} setIsVisible={setIsPasswordChangeVisible} />
        </div>
    );
};

const HamburgerMenu = ({ isVisible, setIsVisible }) => {
    const [isProfileOpen, setIsProfileOpen] = useState(false);
    const navigate = useNavigate();
    const { darkMode, toggleDarkMode } = useDarkMode();

    const handleProfile = () => {
        setIsProfileOpen(true);
    };

    const handleLogout = () => {
        document.cookie.split(";").forEach(cookie => {
            const name = cookie.split("=")[0].trim();
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
        });
        navigate('/');
    };

    document.addEventListener("click", function (event) {
        const menu = document.getElementById("menu");
        const hamburger = document.getElementById("hamburger");

        // Check if the click is outside the hamburger button and the menu button
        if (!hamburger.contains(event.target) && !menu.contains(event.target)) {
            setIsVisible(false);
        }
    });

    if (!isVisible) return null;

    return (
        <div id="hamburger" className="absolute right-0 mt-4 w-48 bg-white dark:bg-gray-800 rounded-md border-2 border-black dark:border-white">
            <ul className="text-black dark:text-white">
                <button
                    className="flex items-center justify-between w-full px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 hover:rounded-md"
                    onClick={() => navigate('/dashVenditore')}
                >
                    <Home size={20} className="text-yellow-500" /> Home
                </button>
                <button
                    className="flex items-center justify-between w-full px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 hover:rounded-md"
                    onClick={() => navigate('/dashVenditore/codici')}
                >
                    <QrCode size={20} className="text-purple-500" /> Codici QR
                </button>
                <button
                    className="flex items-center justify-between w-full px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700"
                    onClick={handleProfile}
                >
                    <UserRound size={20} className="text-blue-500" /> Profilo
                </button>
                <button
                    className="flex items-center justify-between w-full px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700"
                    onClick={handleLogout}
                >
                    <LogOut size={20} className="text-red-500" /> Logout
                </button>
            </ul>
            <div className="border-t border-gray-200 dark:border-gray-700 text-black dark:text-white">
                <button
                    className="flex items-center justify-between w-full px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 hover:rounded-md"
                    onClick={() => toggleDarkMode(true, infoUtente['ID'])}
                >
                    {darkMode ? (
                        <>
                            <Sun size={20} className="text-yellow-500" /> Modalità Chiara
                        </>
                    ) : (
                        <>
                            <Moon size={20} className="text-blue-900" /> Modalità Scura
                        </>
                    )}
                </button>
            </div>
            <PopUpProfilo
                isVisible={isProfileOpen}
                setIsVisible={setIsProfileOpen}
            />
        </div>
    );
};

export const loadNav = async () => {

    const idUser = TempStorage.exists('tokenVenditore') ? TempStorage.get('tokenVenditore') : document.cookie.indexOf('tokenVenditore') !== -1 ? document.cookie.split('tokenVenditore=')[1].split(";")[0] : null;
    try {
        isLoading = true;
        const response = await fetch('/getUser', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ IDUser: idUser }),
        });

        const data = await response.json();

        if (response.status === 500) {
            alert(data.error);
            console.log(data.error);
        }
        else {
            isLoading = false;
            infoUtente = data[0];
        }

    } catch (error) {
        alert("Errore nell'operazione");
        console.log(error);
    }
};

const NavBar = ({ page }) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const navigate = useNavigate();
    const { darkMode } = useDarkMode();

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    }


    return (
        <nav className="flex items-center justify-between px-4 py-2 border-b-2 border-black dark:border-white bg-white dark:bg-gray-800 grid grid-cols-3 fixed w-full z-50">
            {isLoading && <Loader />}
            <div className="md:text-xl font-bold text-black dark:text-white justify-self-start flex items-center">
                <img src={darkMode ? "/LogoLight.png" : "/LogoDark.png"} alt="logo" className="h-5 md:h-10" />MANTEGO
                <p onClick={() => navigate('/dashVenditore')} className="text-xl text-yellow-500 md:p-2 cursor-pointer">
                    <Home size={24} />
                </p>
            </div>
            <div className="md:text-xl font-bold text-black dark:text-white justify-self-center">
                <p onClick={() => window.location.reload()} className="cursor-pointer">{page}</p>
            </div>

            <div className="relative justify-self-end">
                <button
                    id="menu"
                    className="p-2 text-black dark:text-white"
                    onClick={toggleMenu}
                >
                    <Menu size={24} />
                </button>
                <HamburgerMenu
                    isVisible={menuOpen}
                    setIsVisible={setMenuOpen}
                    infoUser={infoUtente}
                />
            </div>
        </nav>
    );
};

export default NavBar;
